var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-section"},_vm._l((_vm.tabsList),function(item,index){return _c('div',{key:index,staticClass:"tab-item",class:{ 'item-active': _vm.tabValue == item.value },on:{"click":function($event){return _vm.handleClickItem(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }